import { Link, TableCell, TableRow, Text } from "@softmax/design-system";
import { fonts } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { PolicyDirectoryRecord } from "./policy-directory-records";

export function PolicyDirectoryRow({
  row,
  layout,
}: {
  readonly row: PolicyDirectoryRecord;
  readonly layout: "page" | "workspace";
}) {
  return (
    <TableRow>
      <TableCell>
        <div
          {...stylex.props(
            styles.name,
            layout === "workspace" && styles.workspaceName,
          )}
        >
          <Link focus="native" href={row.href} title={row.name}>
            {row.name}
          </Link>
        </div>
      </TableCell>
      <TableCell
        truncate={layout === "workspace"}
        title={row.owner.title ?? row.owner.label}
      >
        {row.owner.href ? (
          <Link focus="native" href={row.owner.href} title={row.owner.title}>
            {row.owner.label}
          </Link>
        ) : (
          <span title={row.owner.title}>
            <Text size="small" tone="muted">
              {row.owner.label}
            </Text>
          </span>
        )}
      </TableCell>
      <TableCell align="end">
        {row.versionCount.toLocaleString("en-US")}
      </TableCell>
      <TableCell truncate={layout === "workspace"}>
        <span title={row.created.title} {...stylex.props(styles.timestamp)}>
          <Text size="small" tone="muted">
            {row.created.label}
          </Text>
        </span>
      </TableCell>
    </TableRow>
  );
}

const styles = stylex.create({
  timestamp: { whiteSpace: "nowrap" },
  name: {
    fontFamily: fonts.interface,
    minWidth: "12rem",
    maxWidth: "30rem",
    overflowWrap: "anywhere",
  },
  workspaceName: {
    fontFamily: fonts.sans,
    fontWeight: 500,
    minWidth: 0,
    maxWidth: "none",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});
